import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import {
	envAwarePost,
	dateToAPIStandard
} from '../../util/util'

export const applyUpdatesToAssignedPipelines = createAsyncThunk(
	'applyUpdatesToAssignedPipelines',
	async (payload)=> await envAwarePost(
		'api/automations/',
		{
			action:'applyUpdatesToAssignedPipelines',
			...payload
		}
	)
)

export const getOnboardingPipelines = createAsyncThunk(
	'getOnboardingPipelines',
	async ()=> await envAwarePost(
		'api/automations/',
		{action:'getOnboardingPipelines'}
	)
)

export const getOnboardingPipelineTriggers = createAsyncThunk(
	'getOnboardingPipelineTriggers',
	async ()=> await envAwarePost(
		'api/automations/',
		{action:'getOnboardingPipelineTriggers'}
	)
)

export const createOnboardingPipeline = createAsyncThunk(
	'createOnboardingPipeline',
	async payload => await envAwarePost(
		'api/automations/',
		{action:'createOnboardingPipeline',...payload}
	)
)

export const updateOnboardingPipeline = createAsyncThunk(
	'updateOnboardingPipeline',
	async payload => await envAwarePost(
		'api/automations/',
		{action:'updateOnboardingPipeline',...payload}
	)
)

export const deleteOnboardingPipeline = createAsyncThunk(
	'deleteOnboardingPipeline',
	async id => await envAwarePost(
		'api/automations/',
		{action:'deleteOnboardingPipeline',id}
	)
)

export const createOnboardingPipelineTrigger = createAsyncThunk(
	'createOnboardingPipelineTrigger',
	async payload => await envAwarePost(
		'api/automations/',
		{action:'createOnboardingPipelineTrigger',...payload}
	)
)

export const deleteOnboardingPipelineTrigger = createAsyncThunk(
	'deleteOnboardingPipelineTrigger',
	async payload => await envAwarePost(
		'api/automations/',
		{action:'deleteOnboardingPipelineTrigger',...payload}
	)
)

export const assignOnbardingPipeline = createAsyncThunk(
	'assignOnbardingPipeline',
	async payload => await envAwarePost(
		'api/automations/',
		{action:'assignOnbardingPipeline',...payload}
	)
)

export const unassignOnbardingPipeline = createAsyncThunk(
	'unassignOnbardingPipeline',
	async payload => await envAwarePost(
		'api/automations/',
		{action:'unassignOnbardingPipeline',...payload}
	)
)

export const createOnboardingPipelineItem = createAsyncThunk(
	'createOnboardingPipelineItem',
	async payload => await envAwarePost(
		'api/automations/',
		{action:'createOnboardingPipelineItem',...payload}
	)
)

export const updateOnboardingPipelineItem = createAsyncThunk(
	'updateOnboardingPipelineItem',
	async payload => await envAwarePost(
		'api/automations/',
		{action:'updateOnboardingPipelineItem',...payload}
	)
)

export const deleteOnboardingPipelineItem = createAsyncThunk(
	'deleteOnboardingPipelineItem',
	async id => await envAwarePost(
		'api/automations/',
		{action:'deleteOnboardingPipelineItem',id}
	)
)

export const getProspectiveClients = createAsyncThunk(
	'getProspectiveClients',
	async ()=> await envAwarePost(
		'api/users/',
		{action:'getProspectiveClients'}
	)
)

export const createProspect = createAsyncThunk(
	'createProspect',
	async payload => await envAwarePost(
		'api/users/',
		{action:'createProspectiveClient',...payload}
	)
)

export const updateProspect = createAsyncThunk(
	'updateProspect',
	async payload => await envAwarePost(
		'api/users/',
		{action:'removeClient',...payload}
	)
)

export const removeProspect = createAsyncThunk(
	'removeProspect',
	async client_id => await envAwarePost(
		'api/users/',
		{action:'removeClient',client_id}
	)
)

export const convertProspect = createAsyncThunk(
	'convertProspect',
	async id => await envAwarePost(
		'api/users/',
		{action:'convertProspectiveClient',id}
	)
)

const prospectAdapter = createEntityAdapter({
	selectId: ent=>ent.user_id_number
})

const pipelineAdapter = createEntityAdapter()

const slice = createSlice({
	name: 'growth',
	initialState : {
		pipelines:pipelineAdapter.getInitialState({
			status:'init',
			triggers:{
				status:'init',
				list:[]
			},
			addItemModal:{
				show:false,
				day:1,
			},
			editItemModal:{
				show:false,
				id:null
			},
			assignModal:{
				id:null,
				show:false
			},
			assignmentsEditor:{
				id:null,
				show:false
			},
			updateAssignmentsModal:{
				show:false
			}
		}),
		prospects:prospectAdapter.getInitialState({
			status:'init',
			//not all custom app owners may have the CRM updates
			//if they do not we don't want to show the chat option
			//because their prospects won't be able to chat with 
			//them so if they do not have the crm we hide the 
			//prospect chat options
			hasCRM:false,
			viewer:{
				show:false,
				id:null,
				mode:'view'
			},
			creator:{
				show:false
			}
		})
	},
	reducers : {
		setHasCRM:(state,action)=>{
			state.hasCRM = action.payload
		},
		setPipelineAssignModal:(state,action)=>{
			state.pipelines.assignModal = {
				...state.pipelines.assignModal,
				...action.payload
			}
		},
		setPipelineAssignmentsEditor:(state,action)=>{
			state.pipelines.assignmentsEditor = {
				...state.pipelines.assignmentsEditor,
				...action.payload
			}
		},
		setUpdateAssignmentsModal:(state,action)=>{
			state.pipelines.updateAssignmentsModal = {
				...state.pipelines.updateAssignmentsModal,
				...action.payload
			}
		},
		setProspectViewer:(state,action)=>{
			state.prospects.viewer = {
				...state.prospects.viewer,
				...action.payload
			}
		},
		toggleCreator:(state,action)=>{
			state.prospects.creator.show = !state.prospects.creator.show
		},
		setAddItemModal:(state,action)=>{
			state.pipelines.addItemModal = {
				...state.pipelines.addItemModal,
				...action.payload
			}
		},
		setEditItemModal:(state,action)=>{
			state.pipelines.editItemModal = {
				...state.pipelines.editItemModal,
				...action.payload
			}
		}
	},
	extraReducers : (builder)=>{
		builder
			.addCase(getProspectiveClients.pending,(state)=>{
				state.prospects.status = 'pending'
			})
			.addCase(getProspectiveClients.fulfilled,(state,action)=>{
				state.prospects.status = 'idle'
				if(action.payload.success==='0') return
				prospectAdapter.setAll(state.prospects,action.payload.data.prospects)
			})
			.addCase(getOnboardingPipelines.pending,(state)=>{
				state.pipelines.status = 'pending'
			})
			.addCase(getOnboardingPipelines.fulfilled,(state,action)=>{
				state.pipelines.status = 'idle'
				if(action.payload.success==='0') return
				pipelineAdapter.setAll(state.pipelines,action.payload.data.onboarding_pipelines)
			})
			.addCase(updateProspect.pending,(state,action)=>{

				const {
					client_id,
					new_user_name,
					new_user_id,
					new_email,
					new_phone,
					new_user_email,
					new_profile_pic_url
				} = action.meta.arg

				prospectAdapter.updateOne(state.prospects,{
					id:client_id,
					changes:{
						user_id:new_user_id,
						user_email:new_user_email,
						user_name:new_user_name,
						phone:new_phone,
						profile_pic:new_profile_pic_url
					}
				})

			})
			.addCase(removeProspect.pending,(state,action)=>{
				prospectAdapter.removeOne(state.prospects,action.meta.arg)
			})
			.addCase(convertProspect.pending,(state,action)=>{
				prospectAdapter.removeOne(state.prospects,action.meta.arg)
			})
			.addCase(createProspect.fulfilled,(state,action)=>{
				prospectAdapter.upsertOne(state.prospects,action.payload.data.prospect)
			})
			.addCase(createOnboardingPipeline.fulfilled,(state,action)=>{
				pipelineAdapter.upsertOne(state.pipelines,action.payload.data.onboarding_pipeline)
			})
			.addCase(updateOnboardingPipeline.pending,(state,action)=>{
				const {id,update:changes} = action.meta.arg
				pipelineAdapter.updateOne(
					state.pipelines,
					{id,changes}
				)
			})
			.addCase(createOnboardingPipelineItem.fulfilled,(state,action)=>{
				pipelineAdapter.upsertOne(state.pipelines,action.payload.data.onboarding_pipeline)
			})
			.addCase(updateOnboardingPipelineItem.fulfilled,(state,action)=>{
				pipelineAdapter.upsertOne(state.pipelines,action.payload.data.onboarding_pipeline)
			})
			.addCase(deleteOnboardingPipelineItem.fulfilled,(state,action)=>{
				pipelineAdapter.upsertOne(state.pipelines,action.payload.data.onboarding_pipeline)
			})
			.addCase(deleteOnboardingPipeline.pending,(state,action)=>{
				pipelineAdapter.removeOne(state.pipelines,action.meta.arg)
			})
			.addCase(getOnboardingPipelineTriggers.pending,(state,action)=>{
				state.pipelines.triggers.status = 'pending'
			})
			.addCase(getOnboardingPipelineTriggers.fulfilled,(state,action)=>{
				state.pipelines.triggers.status = 'idle'
				if(action.payload.success==='0') return
				state.pipelines.triggers.list = action.payload.data.onboarding_pipeline_triggers
			})
			.addCase(createOnboardingPipelineTrigger.fulfilled,(state,action)=>{
				pipelineAdapter.upsertOne(state.pipelines,action.payload.data.onboarding_pipeline)
			})
			.addCase(deleteOnboardingPipelineTrigger.fulfilled,(state,action)=>{
				pipelineAdapter.upsertOne(state.pipelines,action.payload.data.onboarding_pipeline)
			})
			.addCase(assignOnbardingPipeline.fulfilled,(state,action)=>{
				pipelineAdapter.upsertOne(state.pipelines,action.payload.data.onboarding_pipeline)
			})
			.addCase(unassignOnbardingPipeline.fulfilled,(state,action)=>{
				pipelineAdapter.upsertOne(state.pipelines,action.payload.data.onboarding_pipeline)
			})
			.addCase(applyUpdatesToAssignedPipelines.fulfilled,(state,action)=>{
				pipelineAdapter.upsertOne(state.pipelines,action.payload.data.onboarding_pipeline)
			})
	}
})

export const {
	setPipelineAssignmentsEditor,
	setUpdateAssignmentsModal,
	setPipelineAssignModal,
	setProspectViewer,
	setEditItemModal,
	setAddItemModal,
	toggleCreator,
	setHasCRM
} = slice.actions


export const prospectSelectors = prospectAdapter.getSelectors(
	state=>state.growth.prospects
)

export const pipelineSelectors = pipelineAdapter.getSelectors(
	state=>state.growth.pipelines
)


export default slice.reducer